import { SagaIterator } from 'redux-saga';
import { call, take, takeEvery } from 'redux-saga/effects';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { App } from '@ps20-frontend/frontend-models';
import {
  GlobalActions,
  GlobalPut,
  ModalCloseReason,
  ModalType,
} from '@ps20-frontend/shop-integration-redux';
import { VhvActions } from '../vhvActions';

export function* watchResetAdressdatenRequested(): SagaIterator {
  yield takeEvery(
    VhvActions.RESET_ADRESSDATEN_REQUESTED,
    safeSaga(resetAdressdatenRequestedHandler, App.VHV),
  );
}

export function* resetAdressdatenRequestedHandler(): SagaIterator {
  yield call(
    GlobalPut.getInstance().put,
    new GlobalActions().requestModal(ModalType.RESET_ADRESSDATEN_WARNING),
  );
  const closeModalAction = yield take(GlobalActions.CLOSE_MODAL);
  if (closeModalAction.payload === ModalCloseReason.PRIMARY) {
    yield call(GlobalPut.getInstance().put, new VhvActions().resetAdressdaten());
  }
}
